import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["platforms", "yAxis"];

  connect() {
    this.chart = Chartkick.charts['topic-analytics'];

    $(this.element).on("change", "input, select", (event) => {
      // Bootstrap has a bug with button toggle groups where the individual buttons are for checkboxes
      // In this scenario, the change event on the input will be fired twice; filter out one of the duplicate events
      this.update(event);
    });
    this.barClickHandler();
  }

  disconnect() {
    $(this.element).off("change");
    this.chart.destroy();
  }

  barClickHandler() {
    var options = this.chart.chart.options;
    var rawData = this.chart.rawData
    options.onClick = function (evt) {
      var activePoint = this.chart.getElementAtEvent(evt)[0];
      if (activePoint == undefined) return false;
      var data = activePoint._chart.data;
      var datasetIndex = activePoint._datasetIndex;
      var query_id = rawData[datasetIndex].id;
      var published_at = data.labels[activePoint._index];
      var href = window.location.href.replace(window.location.pathname, "/queries/" + query_id + "?published_at=" + published_at)
      window.location.href = href;
    }
  }

  beforeUpdate() {
    this.progressBar = new Turbolinks.ProgressBar();
    this.progressBar.setValue(0);
    this.progressBar.show();
  }

  afterUpdate() {
    this.progressBar.setValue(1);
    this.progressBar.hide();
  }

  updateView() {
    this.applyChartType('ColumnChart');

    var options = this.chart.getOptions();
    this.chart.setOptions(options);
    this.barClickHandler();
  }

  applyChartType(type) {
    if(this.chart.__chartName() == type) return;
    var chartElement = this.chart.getElement();
    var chartDataSource = this.chart.getDataSource();
    var chartOptions = this.chart.getOptions();
    this.chart.destroy();
    this.chart = new Chartkick[type](chartElement, chartDataSource, chartOptions);
  }

  update(event) {
    this.beforeUpdate();

    var newUrl = this.buildUrl();
    if(newUrl != this.currentUrl) {
      this.currentUrl = newUrl;

      $.get(newUrl, (response) => {
        this.chart.updateData(response.data);
        this.updateView();
        this.afterUpdate();
      });
    }
    else {
      this.updateView();
      this.afterUpdate();
    }
  }

  buildUrl() {
    var params = $("input, select", this.optionsTargets).serializeArray();
    var regexp = new RegExp("^" + 'topic-analytics');
    for(const param of params) param.name = param.name.replace(regexp, "");

    return this.data.get("baseUrl") + "?" + $.param(params);
  }
}
